import { Route, Routes } from "react-router-dom";
import IndexPage from "./IndexPage";
import OverviewPage from "./OverviewPage";
import SingleMonthForecastPage from "./SingleMonthForecastPage";
import ProductCategoriesPage from "./categories";

const SalesForecastRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route index element={<IndexPage />} />
        <Route path=":mode" element={<OverviewPage />} />
        <Route path=":mode/categories/*" element={<ProductCategoriesPage />} />
        <Route
          path=":mode/:month/:forecastCategoryId"
          element={<SingleMonthForecastPage />}
        />
      </Route>
    </Routes>
  );
};

export default SalesForecastRoutes;
